import React, { useCallback } from "react";
import { useTranslation } from "react-i18next";
import { useLocation, useNavigate } from "react-router";
import { Location } from "history";
import Modal from "../../components/Modal";

const CardApplyStopModal: React.FC<CardApplyStopProps> = (props) => {
  /** Location State */
  const location = useLocation() as Location<LocationState>;
  /** Navigate */
  const navigate = useNavigate();
  /** 다국어처리 */
  const { t } = useTranslation();

  /** 신청중단 처리 */
  const clickStop = useCallback(() => {
    navigate("/main", { state: { query: location.state.query, swiperIndex: location.state.swiperIndex, tabIndex: location.state.tabIndex }});
  }, [navigate, location]);

  return (
    <Modal isOpen={props.isStop} onRequestClose={props.closeStop} contentLabel="modal" className="popTyLayer2" overlayClassName="dim" closeTimeoutMS={500}>
      {/*<p className="tit">{t("APPL99.stopPopup01")}</p>*/}
      <p className="message">{t("APPL99.stopPopup04")}</p>
      {/*<p className="subTxt mgt20">{t("APPL99.stopPopup03")}</p>*/}
      <div className="btnWrapTy02">
        <button type="button" className="btnPrimaryTy03" onClick={props.onConfirm ?? clickStop}><span>{t("APPL99.stopButton01")}</span></button>
        <button type="button" className="btnPrimaryTy01" onClick={props.closeStop}><span>{t("APPL99.stopButton02")}</span></button>
      </div>
    </Modal>
  );
}

export default CardApplyStopModal;